import { Icon } from "src/components";
import { useEffect, useState, useId, useRef } from "react";
import { FilterItem } from "src/common/interfaces/filter.interface";
interface Props {
  title?: string;
  filterData?: Array<FilterItem>;
  value?: string | null;
  onChangeInput?: Function;
  onClear?: Function;
  fillSpace?: boolean;
  width?: string;
  multiselect?: boolean;
  placeholder?: string;
}

const Dropdown = (props: Props) => {
  const randId = useId();
  const [isHidden, setIsHidden] = useState(false);
  const [searchableData, setSearchableData] = useState<
    Array<FilterItem> | undefined
  >(props.filterData);
  const dropdownRef = useRef<HTMLDivElement>(null);
  TriggerDropdown(dropdownRef);

  function TriggerDropdown(ref: React.RefObject<HTMLDivElement>) {
    useEffect(() => {
      function handleClickOutside(event: Event) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setIsHidden(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {
    setSearchableData(props.filterData);
  }, [isHidden, props.filterData]);

  const handleChangeInput = (e: string | boolean | Object) => {
    if (props.onChangeInput) {
      props.onChangeInput(e);
      setIsHidden(false);
    }
  };

  const renderDropdown = () => {
    setIsHidden(!isHidden);
  };

  const handleFilterInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (props.filterData) {
      const search = props.filterData.filter((s) =>
        s.text.toLowerCase().includes((e.target as HTMLInputElement).value)
      );
      setSearchableData(search);
    }
  };

  const showSelectedValue = () => {
    if (props.filterData) {
      const found = props.filterData.find((item: FilterItem) => {
        return item.value === props.value;
      });
      if (found) {
        return found.text;
      }
    }
    return props.placeholder || "All";
  };

  const clearSelected = () => {
    if (props.onClear) {
      props.onClear();
    }
  };

  return (
    <div
      className={`mt-2 mb-2 relative ${
        props.fillSpace === undefined ? "flex-1" : ""
      } ${props.width ?? ""} `}
      ref={dropdownRef}
    >
      <div
        onClick={() => renderDropdown()}
        className={`w-full h-13 rounded-full px-4 py-3 bg-white border cursor-pointer transition-all ${
          !isHidden ? "border-gray-200" : "border-black"
        }`}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center w-full">
            <div>
              <span className="text-gray-300 text-sm">{props.title}:</span>
            </div>
            {props.value && props.value.length > 0 ? (
              <div className="flex mx-2 gap-x-2">
                <div className="flex items-center gap-x-2 bg-gray-200 rounded-full px-2 py-1">
                  <span className="text-xs font-semibold">
                    {showSelectedValue()}
                  </span>
                  <Icon
                    name="times"
                    className="fill-gray-400 w-2.5 h-2.5"
                    onClick={clearSelected}
                  />
                </div>
              </div>
            ) : (
              <div className="mx-2 text-sm">{props.placeholder || "All"}</div>
            )}
          </div>
          <div>
            <Icon name="chevron" className="-rotate-90 w-3 h-3 fill-gray-400" />
          </div>
        </div>
      </div>
      {isHidden && (
        <div className="absolute w-full z-10 mt-1 bg-white border-b rounded-b-2xl">
          <div className="px-4 py-3 flex bg-white items-center border border-gray-200 rounded-t-2xl">
            <Icon
              name="magnifying-glass"
              className="stroke-gray-300 fill-gray-300 w-5 h-5"
            />
            <input
              type="text"
              placeholder="Search"
              className="outline-none pl-2 w-full"
              onKeyUp={handleFilterInput}
            />
          </div>
          <div className="border border-gray-200 border-t-0 border-b rounded-b-2xl">
            <div className="overflow-y-auto max-h-96">
              {searchableData &&
                searchableData.map((list: FilterItem, index: number) => {
                  return (
                    <div
                      className="px-4 py-3 cursor-pointer hover:bg-gray-50 border-b border-gray-200 last:border-b-0"
                      onClick={() => handleChangeInput(list.value)}
                      key={`${randId}_${index}`}
                    >
                      <span>{list.text}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
